import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_idprint } from "../shared/data.service";

import { wsPrintQueueInfo } from "../shared/wsPrintQueueInfo";
import { wsPrintSchoolTemplateInfo } from "../shared/wsPrintSchoolOptionsInfo";

import { wsPrintQueueSetCardParm } from "../shared/wsPrintQueueSetCardParm";
import { wsSetCardInfo } from "../shared/wsPrintQueueSetCardParm";

import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./setcard.component.html",
	styleUrls: ["./setcard.component.css"],
})
export class SetCardComponent implements OnInit, OnDestroy {
	constructor(private dataService: DataService_idprint, public ref: DynamicDialogRef, public dialogConfig: DynamicDialogConfig) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public lstPrintQueueChecked: wsPrintQueueInfo[] = [];
	public lstStaffCard: wsPrintSchoolTemplateInfo[] = [];
	public lstStudentCard: wsPrintSchoolTemplateInfo[] = [];
	public SelectedStaffCard: wsPrintSchoolTemplateInfo;
	public SelectedStudentCard: wsPrintSchoolTemplateInfo;

	public StaffCount: number = 0;
	public StudentCount: number = 0;
	public ItemsChangedMessage: string = "";
	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.lstPrintQueueChecked = this.dialogConfig.data.lstPrintQueueChecked;
		this.lstStaffCard = this.dialogConfig.data.lstStaffCard;
		this.lstStudentCard = this.dialogConfig.data.lstStudentCard;

		this.ItemsChangedMessage = "A total of " + this.lstPrintQueueChecked.length + " item(s) will have their card set.";

		this.lstStaffCard.unshift({
			IDCardTemplateID: "",
			CardName: "No card Specified",
		});

		this.SelectedStaffCard = this.lstStaffCard[0];

		this.lstStudentCard.unshift({
			IDCardTemplateID: "",
			CardName: "No card Specified",
		});

		this.SelectedStudentCard = this.lstStudentCard[0];

		this.lstPrintQueueChecked.forEach((item) => {
			if (item.IsStaff == true) {
				this.StaffCount++;
			} else {
				this.StudentCount++;
			}
		});

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStudentCardChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStudentCardChange(value) {
		this.SelectedStudentCard = value;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStaffCardChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStaffCardChange(value) {
		this.SelectedStaffCard = value;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetCard
	//
	//-----------------------------------------------------------------------------------------------------
	onSetCard() {
		let parms: wsPrintQueueSetCardParm = {
			IDCardTemplateIDStudent: this.SelectedStudentCard.IDCardTemplateID,
			IDCardTemplateIDStaff: this.SelectedStaffCard.IDCardTemplateID,
			SetCardItems: [],
		};

		this.lstPrintQueueChecked.forEach((item) => {
			let r: wsSetCardInfo = {
				IDPrintQueueID: item.IDPrintQueueID,
				IsStaff: item.IsStaff,
			};

			parms.SetCardItems.push(r);
		});

		this.isBusy = true;
		this.dataService.IDPrintQueueSetCard(parms).subscribe((data) => this.IDPrintQueueSetCard_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueSetCard_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueSetCard_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
